export const MAIN_STREET_INDEX_ROUTE = `${process.env.REACT_APP_MAIN_STREET_URI}/clients/manage/homeowners`
